<template>
  <div class="messages-list">
    <img v-if="boImage" :src="boImage" alt="Image Bo de Wit">

    <div class="list">
      <div
          v-if="messages && messages.length > 0"
          class="message"
          v-for="message in messages"
      >
        <span class="time light">
          {{ formatDateTime(message.updated_at) }}
        </span>

        <h5>Bo zegt:</h5>

        <p>
          {{ message.message }}
        </p>
      </div>

      <div class="message" v-else>
        <p>Er zijn geen nieuwe berichten</p>
      </div>
    </div>
  </div>
</template>

<script>
import bo from "../../../assets/images/bo-messages.png"
import {dateTime} from "../../../utils/filters.js"; // Ensure this function exists

export default {
  name: "MessagesList",
  props: [
    "messages",
  ],
  methods: {
    formatDateTime(date) {
      return dateTime(date); // Use the imported function here
    }
  },
  data() {
    return {
      boImage: bo,
    };
  },
};
</script>
